import Vue from "vue";
import Router from "vue-router";
import homePage from "@/page/homePage";
import content from "@/page/content";

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: "/",
      name: "homePage",
      component: homePage,
      redirect: "/all",
      children: [
        {
          path: ":contentType",
          component: content
        },
        { path: ":contentType/:caseName", component: content }
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js